export const SUPPORTS_ARRAY_PROTOTYPE_FILL = "fill" in Array.prototype;
